<template>
  <b-container class="m-2" fluid>
    <b-overlay :show="submitting">
      <template v-slot:overlay>
        <div class="text-center">
          <b-icon-stopwatch font-scale="3" animation="cylon"></b-icon-stopwatch>
          <p id="cancel-label">Saving, please wait...</p>
        </div>
      </template>

      <b-row>
        <b-col>
          <h4 class="text-center">Profile</h4>
          <hr />
          <b-row>
            <b-col>
              <b-form
                @submit.stop.prevent="onSubmit"
                :class="{
                  'needs-validation': !submitted,
                  'was-validated': submitted
                }"
                novalidate
                ref="frm"
              >
                <b-row>
                  <b-col class="justify-content-start">
                    <b-form-group
                      title="Details"
                      :invalid-feedback="validationStat['fn'].msg"
                      label="First Name:"
                      :label-cols="2"
                      label-align="right"
                    >
                      <b-input
                        v-model="pf.first_name"
                        :state="validationStat['fn'].stat"
                        required
                        @blur="onBlur($event.target)"
                        id="fn"
                        :maxlength="255"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="justify-content-start">
                    <b-form-group
                      title="Details"
                      :invalid-feedback="validationStat['ln'].msg"
                      label="Last Name:"
                      :label-cols="2"
                      label-align="right"
                    >
                      <b-input
                        v-model="pf.last_name"
                        :state="validationStat['ln'].stat"
                        required
                        @blur="onBlur($event.target)"
                        id="ln"
                        :maxlength="255"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="justify-content-start">
                    <b-form-group
                      title="Details"
                      :invalid-feedback="validationStat['em'].msg"
                      label="Email:"
                      :label-cols="2"
                      label-align="right"
                    >
                      <b-input
                        v-model="pf.email"
                        :state="validationStat['em'].stat"
                        required
                        type="email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        @blur="onBlur($event.target)"
                        id="em"
                        :maxlength="255"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="justify-content-start">
                    <b-form-group
                      title="Details"
                      :invalid-feedback="validationStat['pw'].msg"
                      label="Password:"
                      :label-cols="2"
                      label-align="right"
                    >
                      <b-input
                        type="password"
                        v-model="pf.password"
                        :state="validationStat['pw'].stat"
                        @blur="onBlur($event.target)"
                        id="pw"
                        :maxlength="255"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="needPassword">
                  <b-col class="justify-content-start">
                    <b-form-group
                      title="Details"
                      :invalid-feedback="validationStat['pw2'].msg"
                      label="Confirm password:"
                      :label-cols="2"
                      label-align="right"
                    >
                      <b-input
                        type="password"
                        v-model="pf.re_password"
                        :state="validationStat['pw2'].stat"
                        @blur="onBlur($event.target)"
                        id="pw2"
                        :maxlength="255"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex justify-content-center">
                    <b-button variant="blue" type="submit" style="width:150px;"
                      >Save</b-button
                    >
                  </b-col>
                  <b-col class="d-flex justify-content-center">
                    <b-button variant="orange" @click="onCancel"
                      >Cancel</b-button
                    >
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
const input = ["fn", "ln", "em", "pw", "pw2"];
import notify from "devextreme/ui/notify";

export default {
  props: ["returnUrl"],
  data() {
    return {
      submitted: false,
      submitting: false,
      validationStat: [],
      pf: {}
    };
  },
  created() {
    debugger;
    input.forEach(ip => (this.validationStat[ip] = { msg: "", stat: null }));
  },
  mounted() {
    this.pf = this.profile;
    this.pf.password = "";
    this.pf.re_password = "";
  },
  computed: {
    profile() {
      return this.$store.getters["user/proFile"];
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.submitting = true;

      if (!e.target.checkValidity()) {
        var elements = e.target.getElementsByTagName("input");
        this.submitting = false;

        input.forEach(el => {
          var ie = elements[el];

          var stat = this.validationStat;
          if (stat) {
            this.validationStat[el].msg = ie.validationMessage;
            this.validationStat[el].stat = ie.checkValidity();
          }
        });

        return;
      }

      debugger;
      if (this.pf.password !== this.pf.re_password) {
        notify(
          "Password does not match confirm password field.",
          "error",
          4000
        );
        this.submitted = false;
        this.submitting = false;
        return;
      }
      debugger;
      return this.$store.dispatch("user/proFile", this.pf).then(rsp => {
        if (rsp) {
          this.reset();
        } else {
          this.submitted = false;
          this.submitting = false;
          return;
        }
      });
    },
    onCancel() {
      debugger;
      this.reset();
      var url = this.returnUrl ? this.returnUrl : "/admin";
      this.$router.push(url);
    },
    onBlur(e) {
      debugger;
      this.validationStat[e.id].stat = e.checkValidity()
        ? e.checkValidity()
        : null;
      this.validationStat[e.id].msg = e.validationMessage
        ? e.validationMessage
        : null;
    },
    needPassword() {
      debugger;
      if (!this.pf) {
        return false;
      }
      var rsp = false;

      if (this.pf.password) {
        debugger;
        rsp = this.pf.password.length > 0;
      }

      return rsp;
    },
    reset() {
      this.submitted = false;
      this.submitting = false;
      this.$router.push("/admin");
      // this.profile.password = "";
      // this.profile.re_password = "";
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/profile.vue